import { PUT_VIDEOS } from "../constants/actionTypes";

export function putVideos(videos) {
    return {
        type: PUT_VIDEOS,
        payload: videos
    };
}
